import { useEffect, useState } from "react";
import { TrendingUp, Loader2 } from "lucide-react";
import { Reveal } from "./Reveal";
import api from "../lib/api";

const LeadingStatsSection = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/leadingstats").then((r) => setStats(r.data)).catch(() => setStats([]));
  }, []);

  const groups = {};
  (stats || []).forEach((s) => {
    const key = s.stat_type || "Stats";
    (groups[key] = groups[key] || []).push(s);
  });

  return (
    <section id="leading-stats" className="relative py-10 md:py-14">
      <Reveal>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tighter flex items-center gap-3">
          <TrendingUp className="h-6 w-6 text-flame" /> Leading stats
        </h2>
        <p className="mt-2 text-muted-foreground">Who's topping the charts around Morbi — goals, assists and more.</p>
      </Reveal>

      {stats === null ? (
        <div className="mt-8 grid place-items-center py-12 text-muted-foreground" data-testid="leadingstats-loading">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : Object.keys(groups).length === 0 ? (
        <div className="mt-8 rounded-3xl border-2 border-dashed border-foreground/15 p-10 text-center" data-testid="leadingstats-empty">
          <TrendingUp className="h-8 w-8 mx-auto text-muted-foreground" />
          <p className="mt-3 font-display font-bold text-lg">No stats recorded yet</p>
          <p className="text-sm text-muted-foreground mt-1">Top scorers and creators will appear here once the games start.</p>
        </div>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          {Object.entries(groups).map(([type, entries], gi) => (
            <Reveal key={type} delay={0.04 * Math.min(gi, 4)}>
              <div data-testid="leadingstats-card" className="h-full rounded-3xl bg-card border border-foreground/10 p-6 shadow-sm">
                <h3 className="font-display text-lg font-bold tracking-tight">{type}</h3>
                <ul className="mt-4 space-y-3">
                  {[...entries].sort((a, b) => b.value - a.value).map((s, i) => (
                    <li key={s.id} className="flex items-center gap-3" data-testid="leadingstats-row">
                      <span className={`h-7 w-7 rounded-full grid place-items-center font-mono text-xs shrink-0 ${i === 0 ? "bg-flame text-white" : "bg-muted text-muted-foreground"}`}>
                        {i + 1}
                      </span>
                      <span className="flex-1 min-w-0">
                        <span className="block font-semibold text-sm truncate">{s.player}</span>
                        {s.team && <span className="block text-xs text-muted-foreground">{s.team}</span>}
                      </span>
                      <span className="font-display text-2xl font-bold text-pitch dark:text-turf">{s.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </section>
  );
};

export default LeadingStatsSection;
